import Phaser from 'phaser';

/**
 * Pointer-down effect that expands the given sprite outwards from the pointer x/y coordinates.
 */
class PointerWaveFX extends Phaser.GameObjects.Sprite {
    private tween?: Phaser.Tweens.Tween;
	constructor(scene: Phaser.Scene, texture: string, frame?: string | number){
		super(scene, 0, 0, texture, frame);
		this.scene = scene;
        this.alpha = 0;
        this.originX = .5;
        this.originY = .5;
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.scene.input.on('pointerdown', this.handlePointerDown);
		this.scene.add.existing(this);
    }
    
    private handlePointerDown(){
        this.x = this.scene.input.activePointer.x;
        this.y = this.scene.input.activePointer.y;
        if (this.tween) this.tween.restart();
        else {
            this.alpha = 1;
            this.scaleX = .1;
            this.scaleY = .1;
            this.tween = this.scene.tweens.add({
                targets: [this],
                ease: Phaser.Math.Easing.Quartic.Out,
                scaleX: 1,
                scaleY: 1,
                alpha: 0,
                duration: 650,
                onComplete: () => {
                    this.alpha = 0;
                    this.tween = undefined;
                }
            })
        }
    }

    public destroy(): void {
        this.scene?.input.removeListener('pointerdown', this.handlePointerDown);
        super.destroy();
    }
}

export default PointerWaveFX;